import { xhttp } from "../Fetchv2.js";
import { PGSchema } from "../schemas/pg.schema.js";
import { DigeducaAi } from "./digeduca-ai.js";

export class Digeduca {
	ai = new DigeducaAi();
	async loginDigeduca(cred: { username: string; registro: string }) {
		let response = await xhttp<{ token: string; data: PGSchema.users }>(`/users_temp/auth/digeduca`, "POST", cred);
		return response;
	}
	async loginDigeducaCodPersonal(cred: { registro: string; birthday: number; EVALUADOS: "GRADUANDOS" | "TERCERO_BASICO" | "SEXTO_PRIMARIA" | "OTROS" }) {
		let response = await xhttp<{ token: string; data: PGSchema.users }>(`/users_temp/auth/digeduca/codpersonal`, "POST", { ...cred });
		return response;
	}
	async getTestPendingByInstitution(institution: string, passwd?: string, director?: boolean) {
		let response = await xhttp<{
			complete?: number;
			incomplete?: number;
			pwd: boolean;
			list?: {
				name: string;
				last_name: string | undefined;
				uid: string;
				complete: boolean;
			}[];
		}>("/digeduca/institution", "POST", { institution, passwd, director });
		return response;
	}
}
